import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Button,
  Box,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useState } from "react";

const PasswordDialog = ({ open, setOpen, onConfirm }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleConfirm = () => {
    onConfirm(password);
    setPassword("");
    setOpen(false);
  };

  const handleCancel = () => {
    setPassword("");
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.stopPropagation();
      }}
      PaperProps={{
        sx: {
          backgroundColor: "#1e1a1c",
          border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: "12px",
          boxShadow: "0 24px 64px rgba(0,0,0,0.6)",
          minWidth: 380,
          overflow: "hidden",
        },
      }}
      slotProps={{
        backdrop: {
          sx: { backdropFilter: "blur(4px)", backgroundColor: "rgba(0,0,0,0.55)" },
        },
      }}
    >
      <Box sx={{ height: 3, background: "linear-gradient(90deg, #2563eb 0%, #3b82f6 100%)" }} />

      <DialogTitle
        sx={{
          backgroundColor: "transparent",
          px: 3,
          pt: 2.5,
          pb: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: "8px",
            backgroundColor: "rgba(37,99,235,0.12)",
            border: "1px solid rgba(37,99,235,0.25)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 18, color: "#2563eb" }} />
        </Box>
        <Typography
          sx={{ fontSize: 18, fontWeight: 500, color: "#f0ece8", letterSpacing: "0.02em" }}
        >
          CONFIRM PASSWORD
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: "transparent", px: 3, py: 1.5, mt: 1 }}>
        <Typography
          sx={{ fontSize: 14, color: "rgba(240,236,232,0.6)", lineHeight: 1.6, mb: 2 }}
        >
          Enter your password to confirm the operation.
        </Typography>
        <TextField
          fullWidth
          autoFocus
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && password) {
              e.stopPropagation();
              handleConfirm();
            }
          }}
          size="small"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((v) => !v)}
                  edge="end"
                  sx={{ color: "rgba(240,236,232,0.4)" }}
                >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              color: "#f0ece8",
              backgroundColor: "rgba(255,255,255,0.04)",
              borderRadius: "8px",
              "& fieldset": { borderColor: "rgba(255,255,255,0.1)" },
              "&:hover fieldset": { borderColor: "rgba(255,255,255,0.2)" },
              "&.Mui-focused fieldset": { borderColor: "#2563eb" },
            },
            "& input::placeholder": { color: "rgba(240,236,232,0.3)" },
          }}
        />
      </DialogContent>

      <DialogActions
        sx={{
          backgroundColor: "transparent",
          px: 3,
          py: 1.5,
          gap: 1,
          justifyContent: "flex-end",
          borderTop: "1px solid rgba(255,255,255,0.06)",
        }}
      >
        <Button
          variant="outlined"
          size="small"
          onClick={handleCancel}
          sx={{
            color: "rgba(240,236,232,0.55)",
            borderColor: "rgba(255,255,255,0.1)",
            borderRadius: "7px",
            textTransform: "none",
            fontWeight: 500,
            fontSize: 12,
            px: 2,
            py: 0.5,
            minWidth: "unset",
            "&:hover": {
              borderColor: "rgba(255,255,255,0.2)",
              backgroundColor: "rgba(255,255,255,0.04)",
              color: "#f0ece8",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          disabled={!password}
          onClick={handleConfirm}
          sx={{
            backgroundColor: "#2563eb",
            borderRadius: "7px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12,
            px: 2,
            py: 0.5,
            minWidth: "unset",
            boxShadow: "0 4px 14px rgba(37,99,235,0.35)",
            "&:hover": { backgroundColor: "#1d4ed8", boxShadow: "0 4px 18px rgba(37,99,235,0.5)" },
            "&.Mui-disabled": { backgroundColor: "rgba(37,99,235,0.3)", color: "rgba(255,255,255,0.3)" },
          }}
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PasswordDialog;